import { InvestigationDetails } from '@/types/QuestionTypes';
import { host } from '@branding/config';
import { useContext } from 'react';
import { DataContext } from '@context/DataContext';
import { usePostHog } from 'posthog-js/react';
import { fetchWithRetry } from '@/network';
import { useAnalytics } from '@hooks/useAnalytics';

interface Params {
	userLanguage: string;
	isLanguageChanged: boolean;
}

export const useQueryGetBranchInvestigationDetails = () => {
	const { sc } = useContext(DataContext);
	const posthog = usePostHog();
	const sessionID = posthog?.get_session_id();
	const { trackRefineEvent } = useAnalytics();

	const getInvestigationDetails = async ({
		isLanguageChanged,
		userLanguage,
	}: Params): Promise<InvestigationDetails | null> => {
		const url = new URL(`${host}/api/branchinvestigationdetails?lang=${userLanguage}`);
		if (sc) {
			url.searchParams.append('sc', sc);
			url.searchParams.append('sendIsOpenedEvent', (!isLanguageChanged).toString());
		}

		const options: RequestInit = {
			headers: {
				'Content-Type': 'application/json',
				'X-Refine-Sessionid': sessionID,
			},
		};

		return fetchWithRetry<InvestigationDetails>(url, options, {
			endpoint: url.toString(),
			analytics: { trackRefineEvent },
		});
	};

	return { getInvestigationDetails };
};
